import { render } from "./SubmitButton.vue?vue&type=template&id=e4db3f94&scoped=true"
import script from "./SubmitButton.vue?vue&type=script&lang=js"
export * from "./SubmitButton.vue?vue&type=script&lang=js"

import "./SubmitButton.vue?vue&type=style&index=0&id=e4db3f94&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e4db3f94"

export default script